"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_url_to_widget_1 = tslib_1.__importDefault(require("./get-url-to-widget"));
exports.default = (function (videoItem, settings) {
    var siteUrl = settings.siteUrl, compId = settings.compId;
    var params = {
        'wix-vod-video-id': videoItem.id,
    };
    return get_url_to_widget_1.default(siteUrl, compId, params);
});
//# sourceMappingURL=get-url-to-video.js.map